<template>
  <div class="select-wrp">
    <transition name="fade">
      <MyPopup v-if="show" :goodsItem="goodsItem" @close="handleClose" @handleAddShop="handleAddShop"></MyPopup>
    </transition>
    <!-- <transition name="ball-transition">
      <div class="ball iconfont" v-show="ballShow">{{'\ue60b'}}</div>
    </transition> -->
    <div class="content">
    <div class="header">
      <van-nav-bar
        title="商品列表"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
      />
      <div class="search-ipt">
        <i class="huisuiyunfont">&#xe61d;</i>
        <input type="text" :value="searchKey" @change="handleQueryChange" placeholder="输入商品名称以搜索" class="search-input" @focus="handleSearchFocus"/>
        <i class="iconfont" @click="handleCloseSearch" v-show="searchShow">{{'\ue60b'}}</i>
        <van-button class="search-button" type="info" v-show="searchShow" @click="search">搜 索</van-button>
      </div>
    </div>
    <section>
       <div v-if="![...selectList, ...searchData].length > 0" >
        <div class="showNoGoods">
          <i class="huixiaopiaofont">&#xe602;</i>
          <div>请新增商品</div>
        </div>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loadingnew"
          :finished="finished"
          finished-text=""
          :immediate-check="false"
          @load="onLoad"
        >
          <div v-if="[...selectList, ...searchData].length > 0" class="goodsList">
            <van-swipe-cell v-for="(item,index) in searchData" :key="index">
              <div class="goods-card" @click="handleGoodsClick(item)">
                <div>
                  <div class="commodity-name">
                    {{ item.shortName ? '*' + (item.shortName.split('*').join('')) + '*' + item.goodsName : item.goodsName }}
                  </div>
                  <div class="specification">
                    <div>
                      <span class="label">规格:</span>
                      <span class="value">{{item.specification ? item.specification : '--'}}</span>
                    </div>
                    <div>
                      <span class="label">单位:</span>
                      <span class="value">{{item.unit ? item.unit : '--'}}</span>
                    </div>
                    <div v-if="item.revenueCode">
                      <span class="label">数量:</span>
                      <span class="value">{{1}}</span>
                    </div>
                    <div v-else>
                      <span class="label">暂无税编</span>
                    </div>
                  </div>
                  <div class="operation">
                    <div>
                      <span class="label">单价:</span>
                      <span class="value iconfont">￥{{item.price ? Number(item.price).toFixed(2) : '--'}}</span>
                    </div>
                    <div>
                      <div :class="`commodity-sub ${ getGoodsNumber(item) ? 'in-operation' : '' }`" @click.stop="handleCutShop(item)">
                        <div>一</div>
                      </div>
                      <div class="sum">
                        {{ getGoodsNumber(item) }}
                      </div>
                      <div class="commodity-add" @click.stop="handleAddShop(item)">
                        ＋
                      </div>
                    </div>
                  </div>
                </div>
                <div class="recommend" v-if="item.order === 1 && !searchKey">置顶</div>
              </div>
              <template #right>
                <van-button square text="置顶" type="primary" class="top-button" @click="setDefaultGoods(item)"/>
              </template>
            </van-swipe-cell>
          </div>
      </van-list>
      </van-pull-refresh>
    </section>
    <div class="footer">
      <div class="footer-sum">
        <div class="footer-sum-top">
          已添加商品明细 （行）
        <!-- 测试数据 -->
        <!-- {{ searchData.length }}
        {{ finished }}
        {{ refreshing }}
        {{ loadingnew }}
        {{ total }} -->
        </div>
        <div class="footer-sum-buttom">
          <div class="length">{{length}}</div>
          <div id="footer-info" class="info" @click="showInfo = true">
            <div>明细</div>
            <div class="right-icon">
              <i class="iconfont">&#xe648;</i>
            </div>
          </div>
        </div>
      </div>
      <van-button @click="gotoAddGoods" class="confirm-btn" type="info" v-if="!this.$route.query.source">维护商品</van-button>
      <van-button @click="confirmSelect" :class="['confirm-btn',this.$route.query.source==='business' ? 'onw-button' : '' ]" type="info">完 成</van-button>
      <van-popup
        v-model="showInfo"
        round
        position="bottom"
        :style="{ height: '40%', bottom: '68px', boxShadow: '0 0 6px rgba(0,0,0,0.2)',}"
        :overlay-style="{ background: 'transparent' }"
      >
        <div class="footer-info">
          <div class="footer-info-title">
            已选商品
           <span class="huisuiyunfont reset-info" @click="handleClearGoods">{{'\ue61c'}}</span>
          </div>
          <div class="select-goods">
            <div v-if="selectGoods && selectGoods.length" class="goodsList" :style="{ paddingBottom: '48px' }">
              <div class="goods-card" v-for="(item,index) in this.selectGoods" :key="index" @click="handleGoodsClick(item)">
                <div>
                  <div class="commodity-name">
                    {{ item.shortName ? '*' + (item.shortName.split('*').join('')) + '*' + item.goodsName : item.goodsName }}
                  </div>
                  <div class="specification">
                    <div>
                      <span class="label">规格:</span>
                      <span class="value">{{item.specification ? item.specification : '--'}}</span>
                    </div>
                    <div>
                      <span class="label">单位:</span>
                      <span class="value">{{item.unit ? item.unit : '--'}}</span>
                    </div>
                    <div v-if="item.revenueCode">
                      <span class="label">数量:</span>
                      <span class="value">{{1}}</span>
                    </div>
                    <div v-else>
                      <span class="label">暂无税编</span>
                    </div>
                  </div>
                  <div class="operation">
                    <div>
                      <span class="label">单价:</span>
                      <span class="value iconfont">￥{{item.price ? Number(item.price).toFixed(2) : '--'}}</span>
                    </div>
                    <div>
                      <div :class="`commodity-sub ${ getGoodsNumber(item) ? 'in-operation' : '' }`" @click.stop="handleCutShop(item)">
                        <div>一</div>
                      </div>
                      <div class="sum">
                        1
                      </div>
                      <div class="commodity-add" @click.stop="handleAddShop(item)">
                        ＋
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else :style="{ width: '100%', textAlign: 'center', color: 'rgba(102, 102, 102, 1)', marginTop: '24px', fontSize: '16px' }">
              暂无数据
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    </div>
  </div>
</template>

<script>
import {
  Field,
  Button,
  Popup,
  Notify,
  Toast,
  NavBar,
  Switch,
  PullRefresh,
  List,
  Dialog,
  SwipeCell
} from 'vant'
import {
  ConvertNumber,
  deepCopy,
  delInArr,
  addToArr,
  onCount,
  NumFormat,
  localStorage,
  getQuery
} from '@utils/basicUtil'
import '@utils/baseProto.js'
import { invoiceRequest } from '@services'
import {
  TAX_RATE
} from '@assets/config'
import MyPopup from '@/components/Popup'
export default {
  data () {
    return {
      show: false,
      loading: false,
      showInfo: false,
      selectGoods: [],
      loadingnew: false,
      refreshing: false,
      searchShow: false,
      ballShow: true,
      finished: false,
      goodsItem: {},
      goodsMessage: [],
      length: 0,
      nowGoodsMessage: [],
      barRightTitle: '精简模式',
      editType: '',
      editItemIndex: null,
      searchKey: '',
      tableData: [],
      total: 0,
      searchData: [],
      edit: {
        visible: false,
        data: {}
      },
      bgTimer: null,
      moneyError: {
        visible: false,
        selectMoney: 0
      },
      companyId: '',
      current: 1,
      size: 20,
      formData: {},
      source: ''
    }
  },
  computed: {
    setNum () {
      return function (money) {
        if (money === '' || money === null) {
          return '0.00'
        }
        let num = money + ''
        let arr = num.split('.')
        if (arr[1]) {
          return Number(arr[1]) < 10 ? Number(arr[1]) + '0' : num
        } else {
          return money + '.00'
        }
      }
    },
    moneySum () {
      return this.formData.money
    },
    selectList () {
      let { source } = getQuery()
      if (source === 'business') {
        return this.$store.state.invoice.businessGoodsList
      }
      return this.$store.state.invoice.goodsList
    },
    showOperation () {
      let { source } = getQuery()
      if (source === 'business') {
        return this.$store.state.invoice.businessGoodsList.length
      }
      return this.$store.state.invoice.goodsList.length
    },
    showTaxSign () {
      // 0 显示
      // 1 不显示。默认所有商品含税
      // 免税政策 也不显示
      return localStorage.get('showTaxSign') === '0'
    },
    taxRatePecent () {
      if (!this.edit.data.taxRate) {
        return 0
      }
      return TAX_RATE.find(tax => tax.value === this.edit.data.taxRate).title
    },
    autoNumber () {
      return function (num) {
        return NumFormat(Number(num))
      }
    },
    getGoodsNumber () {
      return function (item) {
        if (sessionStorage.nowGoodsMessage) {
          const goods = JSON.parse(sessionStorage.nowGoodsMessage)
          let itemList = goods.filter(i => (i.goodsCode === item.goodsCode && i.goodsName === item.goodsName))
          return itemList.length || 0
        } else {
          return 0
        }
      }
    },
    getSelectGoods () {
      let goods = sessionStorage.nowGoodsMessage && JSON.parse(sessionStorage.nowGoodsMessage)
      return goods || []
    }
  },
  mounted () {
    if (sessionStorage.nowGoodsMessage) {
      this.oldNowGoodsMessage = JSON.parse(sessionStorage.nowGoodsMessage)
      this.length = JSON.parse(sessionStorage.nowGoodsMessage).length
      this.selectGoods = JSON.parse(sessionStorage.nowGoodsMessage)
    }
    this.initSelectData()
    let { source } = getQuery()
    this.source = source
  },
  methods: {
    async setDefaultGoods (item) {
      const data = await invoiceRequest.goods.setDefaultGoods({ id: item.id })
      if (data.success) {
        this.onRefresh()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    handleClearGoods () {
      if (!this.selectGoods.length) {
        this.showInfo = false
        return
      }
      Dialog.confirm({
        message: '是否确认删除已选数据?',
        confirmButtonColor: '#3378FF'
      })
        .then(() => {
          this.selectGoods = []
          this.nowGoodsMessage = []
          sessionStorage.clear()
          this.length = 0
          this.showInfo = false
        })
        .catch(() => {})
    },
    onLoad () {
      this.loadingGoodList()
    },
    handleCloseSearch () {
      this.searchShow = false
      this.searchKey = ''
    },
    handleQueryChange (e) {
      this.searchKey = e.target.value
    },
    // handleSearchBlur () {
    //   this.searchShow = false
    // },
    handleSearchFocus () {
      this.searchShow = true
    },
    handleGoodsClick (item) {
      this.show = true
      this.goodsItem = item
    },
    onRefresh () {
      this.finished = false // 下拉时候是否加载的状态
      this.current = 1
      this.tableData = []
      this.searchData = [] // 卡片数据
      this.initSelectData()
    },
    handleClose () {
      this.show = false
    },
    onClickLeft () {
      if (this.oldNowGoodsMessage) {
        sessionStorage.nowGoodsMessage = JSON.stringify(this.oldNowGoodsMessage)
        sessionStorage.goods = JSON.stringify(this.oldNowGoodsMessage)
      } else {
        sessionStorage.nowGoodsMessage = []
        sessionStorage.goods = []
      }
      this.$router.go(-1)
    },

    handleAddShop (item) {
      let { source } = getQuery()
      if (!item.revenueCode && source === 'business') {
        Notify({ type: 'danger', message: '此商品未维护税收分类编码,请重新选择' })
        return
      }
      let newItem = item
      newItem.amount = Number(newItem.amountWithTax) === 0 ? '' : Number(Number(newItem.amountWithTax) / Number(1 + newItem.taxRate)).toFixed(2)
      newItem.unitPrice = Number(newItem.amount) === 0 ? '' : Number(Number(newItem.amount) / Number(newItem.quantity)).toFixed(2)
      newItem.amountWithTax = Number(newItem.amountWithTax) === 0 ? '' : newItem.amountWithTax
      newItem.taxSign = newItem.taxSign ? 1 : 0
      newItem.price = Number(newItem.price) === 0 ? '' : newItem.price
      console.log(newItem)
      if (sessionStorage.nowGoodsMessage) {
        this.nowGoodsMessage = JSON.parse(sessionStorage.nowGoodsMessage)
      }
      this.nowGoodsMessage.push(newItem)
      this.selectGoods.push(newItem)
      this.length++
      sessionStorage.nowGoodsMessage = JSON.stringify(this.nowGoodsMessage)
      if (this.$store.state.invoice.goodsList.length > 0) {
        for (var index = 0; index < this.$store.state.invoice.goodsList.length; index++) {
          if (this.$store.state.invoice.goodsList[index].goodsName === newItem.goodsName) {
            // this.$store.state.invoice.goodsList[index].quantity++
            sessionStorage.goods = JSON.stringify(this.$store.state.invoice.goodsList)
            this.show = false
            return
          }
        }
        this.$store.state.invoice.goodsList.push(newItem)
      } else {
        this.$store.state.invoice.goodsList.push(newItem)
      }
      sessionStorage.goods = JSON.stringify(this.$store.state.invoice.goodsList)
      this.show = false
    },
    handleCutShop (item) {
      if (sessionStorage.nowGoodsMessage) {
        const nowGoods = JSON.parse(sessionStorage.nowGoodsMessage)
        this.nowGoodsMessage = JSON.parse(sessionStorage.nowGoodsMessage)
        let goodIndex = nowGoods.findIndex(i => (i.goodsCode === item.goodsCode && i.goodsName === item.goodsName))
        if (goodIndex >= 0) {
          this.nowGoodsMessage.splice(goodIndex, 1)
          this.selectGoods.splice(goodIndex, 1)
          this.length--
          sessionStorage.nowGoodsMessage = JSON.stringify(this.nowGoodsMessage)
        }
      }
    },
    handleAdd (item) {
      this.show = true
      this.goodsItem = item
      // this.visible = true
    },
    onClickRight () {
      if (this.barRightTitle === '精简模式') {
        this.barRightTitle = '复杂模式'
      } else {
        this.barRightTitle = '精简模式'
      }
    },
    convertPrice (price) {
      const priceStr = String(price)
      if (priceStr.length > 15) {
        return priceStr.substr(0, 15)
      }
      return price
    },
    sliceStr (text, len) {
      if (text && text.length > len) {
        return text.slice(0, len) + '...'
      } else {
        return text
      }
    },
    calcAmountWithTax (goods) {
      const {
        taxPre,
        taxSign,
        taxRate = 0,
        price,
        quantity = 1
      } = goods
      const calcTaxRate = onCount.add(1, taxRate)
      const tempAmountWithTax = onCount.mul(price, quantity)
      let amountWithTax
      if (taxPre === 1 && this.showTaxSign) {
        // 不免税且显示是否含税标示
        amountWithTax = onCount.mul(tempAmountWithTax, (taxSign ? 1 : calcTaxRate))
      }
      return (amountWithTax || tempAmountWithTax).toFixed(2)
    },
    calcPriceOrQtyWithAmount () {
      const {
        taxPre,
        taxSign,
        price,
        taxRate = 0,
        quantity
      } = this.edit.data
      const amountWithTax = Number(this.edit.data.amountWithTax)
      const calcTaxRate = onCount.add(1, taxRate)
      if (quantity) {
        const tempPrice = onCount.div(amountWithTax, quantity)
        if (taxPre === 1 && this.showTaxSign && !taxSign) {
          // 不免税 && 显示是否含税标示 && 不含税标示
          this.edit.data.price = this.convertPrice(onCount.div(tempPrice, calcTaxRate))
        } else {
          this.edit.data.price = this.convertPrice(tempPrice)
        }
        return
      }
      if (price) {
        const tempQty = onCount.div(amountWithTax, price)
        if (taxPre === 1 && this.showTaxSign) {
          this.edit.data.quantity = onCount.div(tempQty, (taxSign ? calcTaxRate : 1))
        } else {
          this.edit.data.quantity = tempQty
        }
      }
    },
    changeTaxSign (checked) {
      const originPrice = this.edit.data.price
      const calcTaxRate = onCount.add(1, this.edit.data.taxRate)
      if (checked) {
        this.edit.data.price = this.convertPrice(onCount.mul(originPrice, calcTaxRate))
      } else {
        this.edit.data.price = this.convertPrice(onCount.div(originPrice, calcTaxRate))
      }
    },
    gotoAddGoods () {
      this.$router.replace('/invoice/add-goods')
      // this.$router.push('/invoice/add-goods')
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    selectGood (data) {
      const { params } = data
      const { item: v } = params
      const item = deepCopy(v)
      item.select = true
      if (this.searchKey.length === 0 && this.selectList.length === 0) {
        this.searchData = deepCopy(this.tableData)
      }
      let searchDataIndex = null
      this.searchData.forEach((i, j) => {
        if (i.goodsName === item.goodsName) {
          searchDataIndex = j
        }
      })
      if (searchDataIndex !== null) {
        this.searchData = delInArr(this.searchData, searchDataIndex)
      }
      this.selectList.push(item)
    },
    sumPriceFocusHandle () {
      this.sumPriceFocus.focus()
    },
    cancelGood (data) {
      const { params } = data
      const { item: v } = params
      const item = deepCopy(v)
      item.select = false
      let { source } = getQuery()
      if (source === 'business') {
        this.$store.commit('invoice/changeBusinessGoodsList', this.selectList.filter((v) => v.goodsName === item.goodsName ? v.specification !== item.specification : true))
      } else {
        this.$store.commit('invoice/changeGoodsList', this.selectList.filter((v) => v.goodsName === item.goodsName ? v.specification !== item.specification : true))
      }
      this.searchData = addToArr(this.searchData, 0, item)
    },
    editData (item, index) {
      if (!item.select) {
        return
      }
      this.editType = 'edit'
      this.editItemIndex = index
      this.edit.data = deepCopy(item)
      this.edit.data.taxSign = !!((deepCopy(item).taxSign === 1 || deepCopy(item).taxSign === true))
      this.edit.data.price = this.edit.data.price ? this.edit.data.price.toFixed(2) : this.edit.data.price
      this.edit.visible = true
    },
    copyData (item) {
      if (!item.select) {
        return
      }
      this.editType = 'copy'
      this.edit.data = deepCopy(item)
      this.edit.data.taxSign = !!((deepCopy(item).taxSign === 1 || deepCopy(item).taxSign === true))
      this.edit.visible = true
    },
    mulSum () {
      this.edit.data.amountWithTax = this.calcAmountWithTax(this.edit.data)
    },
    testAmount () {
      if (!this.edit.data.amountWithTax || !Number(this.edit.data.amountWithTax)) {
        return Notify({ type: 'danger', message: '请输入正确的合计价格' })
      }
      try {
        this.calcPriceOrQtyWithAmount()
      } catch (e) {
        return Notify({ type: 'danger', message: '请输入商品数量和单价' })
      }
    },
    confirmEdit () {
      this.testAmount()
      let editData = deepCopy(this.edit.data)
      if (editData.amountWithTax && !Number(editData.amountWithTax)) {
        return Notify({ type: 'danger', message: '请输入商品数量和单价' })
      }
      if (this.editType === 'copy') {
        const sameGoodsList = this.selectList.filter(v => v.goodsName === editData.goodsName && v.specification === editData.specification)
        if (sameGoodsList.length) {
          return Notify({ type: 'danger', message: '已存在相同商品，请修改商品的规格型号后再添加' })
        }
      } else {
        const sameGoodsList = this.selectList.filter(v => v.goodsName === editData.goodsName && v.specification === editData.specification)
        if (sameGoodsList.length > 1) {
          return Notify({ type: 'danger', message: '已存在相同商品，请修改商品的规格型号后再添加' })
        }
      }
      if (!editData.quantity && !editData.price) {
        this.edit.data.price = null
        this.edit.data.quantity = null
      } else {
        const tempAmountWithTax = this.calcAmountWithTax(editData)
        if (editData.amountWithTax !== tempAmountWithTax) {
          this.edit.data.amountWithTax = tempAmountWithTax
        }
      }
      if (this.editType === 'copy') {
        // copy ：添加item信息
        this.selectList.push({
          ...this.edit.data,
          select: true,
          taxSign: this.edit.data.taxSign ? 1 : 0
        })
      } else {
        // edit ：更改item信息
        if (this.selectList[this.editItemIndex].goodsName === this.edit.data.goodsName) {
          const resultItem = deepCopy(this.edit.data)
          this.selectList[this.editItemIndex] = resultItem
        }
      }
      let { source } = getQuery()
      if (source === 'business') {
        this.$store.commit('invoice/changeBusinessGoodsList', this.selectList)
      } else {
        this.$store.commit('invoice/changeGoodsList', this.selectList)
      }
      this.edit.visible = false
    },
    confirmSelect () {
      this.$router.go(-1)
    },
    equalMoney () {
      let diff = Number(onCount.sub(this.moneySum, this.moneyError.selectMoney))
      if (diff > 0 || diff === 0) {
        let itemDif = Number(onCount.div(diff, this.selectList.length).toFixed(2))
        let sumDif = 0
        for (let i = 0; i < this.selectList.length - 1; i++) {
          this.selectList[i].amountWithTax = onCount.add(Number(Number(this.selectList[i].amountWithTax).toFixed(2)), Number(itemDif))
          sumDif = Number(onCount.add(Number(this.selectList[i].amountWithTax), Number(sumDif)))
        }
        this.selectList[this.selectList.length - 1].amountWithTax = Number(onCount.sub(Number(this.moneySum), sumDif))
      } else {
        let sumDif = 0
        for (let i = 0; i < this.selectList.length - 1; i++) {
          let bili = onCount.div(Number(this.selectList[i].amountWithTax), Number(this.moneyError.selectMoney))
          let itemSum = onCount.mul(bili, Number(this.moneySum))
          this.selectList[i].amountWithTax = Number(itemSum.toFixed(2))
          sumDif = Number(onCount.add(Number(this.selectList[i].amountWithTax), Number(sumDif)))
        }
        let lastDif = Number(Number(onCount.sub(Number(this.moneySum), Number(sumDif))).toFixed(2))
        if (lastDif < 0) {
          for (let i = 0; i < this.selectList.length; i++) {
            if (this.selectList[i].amountWithTax > Math.abs(lastDif)) {
              this.selectList[i].amountWithTax += lastDif
              break
            }
          }
        } else {
          this.selectList[this.selectList.length - 1].amountWithTax = lastDif
        }
      }
      this.confirmSelect()
    },
    testCount () {
      this.resetScrollTop()
      if (Number(this.edit.data.quantity) < 0) {
        this.edit.data.quantity = Math.abs(Number(this.edit.data.quantity)).toString()
      }
    },
    testPrice () {
      this.resetScrollTop()
      if (!/^\d+$|^\d*\.\d+$/g.test(this.edit.data.price)) {
        if (Number(this.edit.data.price) < 0) {
          this.edit.data.price = Math.abs(Number(this.edit.data.price)).toString()
        } else {
          this.edit.data.price = ''
        }
      }
    },
    resetScrollTop () {
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    },
    async getGoodsList () {
      // 税编缺失，默认申请开票可以查出来，电票直开默认不查标示为business 存在就不查
      let existRevenueCode = ''
      let { source } = getQuery()
      if (source === 'business') {
        existRevenueCode = 1
      }
      this.current = 1
      this.size = 20
      const data = await invoiceRequest.goods.getGoodsList({
        goodName: this.searchKey,
        existRevenueCode,
        current: this.current,
        size: this.size,
        status: 0
      })
      if (data.success) {
        const arr = deepCopy(data.result.records)
        const resArr = arr.map((v, i) => {
          // 免税政策   免税价格
          // 不免税政策 showTaxSign ？原价格 ：含税价格
          // 免税价格：含税标示 ？原价格 / （1+税率） ： 原价格
          // 含税价格：含税标示 ？原价格：原价格*（1+税率）
          const originPrice = v.price
          let resTaxSign = v.taxSign === 1
          let resPrice
          if (!this.showTaxSign && v.taxPre === 1 && !resTaxSign) {
            resTaxSign = true
            resPrice = onCount.mul(originPrice, onCount.add(1, v.taxRate))
          }
          const res = {
            ...v,
            select: false,
            quantity: 1,
            order: i + 1 + (data.result.current - 1) * data.result.size,
            price: this.convertPrice(resPrice || originPrice),
            taxSign: resTaxSign
          }
          res.amountWithTax = this.calcAmountWithTax(res)
          return res
        })
        this.tableData = resArr
        this.total = data.result.total
        this.searchData = deepCopy(resArr)
      } else {
        if (data.success === false) {
          this.finished = true
          Notify({ type: 'danger', message: data.message })
        }
      }
      if (this.tableData.length === Number(this.total)) {
        this.finished = true
      } else {
        this.finished = false
      }
    },
    search () {
      this.searchData = []
      this.tableData = []
      this.current = 1
      this.size = 20
      this.$nextTick()
      this.getGoodsList()
    },
    async loadingGoodList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      if (this.tableData.length === Number(this.total)) {
        this.finished = true
        this.refreshing = false
        this.loadingnew = false
        return
      }
      this.current = this.current + 1
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      let existRevenueCode = ''
      let { source } = getQuery()
      if (source === 'business') {
        existRevenueCode = 1
      }
      const data = await invoiceRequest.goods.getGoodsList({
        goodName: this.searchKey,
        current: this.current,
        size: this.size,
        status: 0,
        existRevenueCode
      })
      if (data.success) {
        const arr = deepCopy(data.result.records)
        const resArr = arr.map((v, i) => {
          // 免税政策   免税价格
          // 不免税政策 showTaxSign ？原价格 ：含税价格
          // 免税价格：含税标示 ？原价格 / （1+税率） ： 原价格
          // 含税价格：含税标示 ？原价格：原价格*（1+税率）
          const originPrice = v.price
          let resTaxSign = v.taxSign === 1
          let resPrice
          if (!this.showTaxSign && v.taxPre === 1 && !resTaxSign) {
            resTaxSign = true
            resPrice = onCount.mul(originPrice, onCount.add(1, v.taxRate))
          }
          const res = {
            ...v,
            select: false,
            quantity: 1,
            order: i + 1 + (data.result.current - 1) * data.result.size,
            price: this.convertPrice(resPrice || originPrice),
            taxSign: resTaxSign
          }
          res.amountWithTax = this.calcAmountWithTax(res)
          return res
        })
        const table = this.tableData
        this.tableData = table.concat(resArr)
        this.searchData = deepCopy(table.concat(resArr))
      } else {
        if (data.success === false) {
          this.finished = true
          Notify({ type: 'danger', message: data.message })
        }
      }
      console.log(this.tableData)
      this.loadingnew = false
      Toast.clear()
    },
    async initSelectData (id) {
      console.log('初始化')
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      let existRevenueCode = ''
      let { source } = getQuery()
      if (source === 'business') {
        existRevenueCode = 1
      }
      const data = await invoiceRequest.goods.getGoodsList({
        goodName: this.searchKey,
        current: this.current,
        size: this.size,
        status: 0,
        existRevenueCode
      })
      if (data.success) {
        const arr = deepCopy(data.result.records)
        const resArr = arr.map((v, i) => {
          // 免税政策   免税价格
          // 不免税政策 showTaxSign ？原价格 ：含税价格
          // 免税价格：含税标示 ？原价格 / （1+税率） ： 原价格
          // 含税价格：含税标示 ？原价格：原价格*（1+税率）
          const originPrice = v.price
          let resTaxSign = v.taxSign === 1
          let resPrice
          if (!this.showTaxSign && v.taxPre === 1 && !resTaxSign) {
            resTaxSign = true
            resPrice = onCount.mul(originPrice, onCount.add(1, v.taxRate))
          }
          const res = {
            ...v,
            select: false,
            quantity: 1,
            order: i + 1 + (data.result.current - 1) * data.result.size,
            price: this.convertPrice(resPrice || originPrice),
            taxSign: resTaxSign
          }
          res.amountWithTax = this.calcAmountWithTax(res)
          return res
        })
        this.tableData = resArr
        this.total = data.result.total
        this.searchData = deepCopy(resArr)
      } else {
        if (data.success === false) {
          this.finished = true
          Notify({ type: 'danger', message: data.message })
        }
      }
      Toast.clear()
    }
  },
  watch: {
    searchKey (v) {
      if (v === '') {
        this.searchShow = false
        this.search()
      } else {
        this.searchShow = true
      }
    }
  },
  destroyed () {
    Toast.clear()
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Switch.name]: Switch,
    [NavBar.name]: NavBar,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [SwipeCell.name]: SwipeCell,
    MyPopup
  },
  beforeRouteUpdate (to, from, next) {
    console.log(to, from)
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
